export const ErrorCancellingJob = "Could not cancel the job because it was already solving. The simulation will continue..."